import { IAppuntamento } from 'app/model/appuntamento';
import { Agenda } from 'app/model/agenda';
import { Observable } from 'rxjs/Observable';
import { NgbDateStruct, NgbActiveModal, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { Component } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { switchMap, map, tap } from 'rxjs/operators';
import * as moment from 'moment';
import { Config } from 'app/config.const';
import { toMoment, toNgbDateStruct } from 'utils';

export interface IPeriod {
	from?: NgbDateStruct;
	to?: NgbDateStruct;
}

export interface IReminder {
	date: string;
	all_day: boolean;
	begin?: string;
	end?: string;
	evento: string;
}

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
	one && two && two.year === one.year && two.month === one.month && two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
	!one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
		? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
	!one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
		? false : one.day > two.day : one.month > two.month : one.year > two.year;

@Component({
	selector: 'app-selezione-periodo',
	templateUrl: './periodo.html',
	styleUrls: ['./periodo.css']
})
export class SelezionePeriodoComponent {

	hoveredDate: NgbDateStruct;
	_fromDate: NgbDateStruct;
	_toDate: NgbDateStruct;

	get fromDate(): NgbDateStruct {
		return this._fromDate;
	}

	set fromDate(value: NgbDateStruct) {
		if (after(value, this.toDate)) {
			this.toDate = null;
		}
		this._fromDate = value;
		this.nextPeriod({ from: this._fromDate, to: this._toDate });
	}

	get toDate(): NgbDateStruct {
		return this._toDate;
	}

	set toDate(value: NgbDateStruct) {
		if (before(value, this.fromDate)) {
			this.fromDate = null;
		}
		this._toDate = value;
		this.nextPeriod({ from: this._fromDate, to: this._toDate });
	}

	paziente: string;

	set agenda(value: Agenda) {
		const periodRequest = new Subject<IPeriod>();
		this.paziente = this.paziente.toUpperCase();
		this.appuntamenti$ = periodRequest.pipe(
			switchMap(({ from, to }) =>
				(from && to) ? value.getEventInRange(toMoment(from), toMoment(to)) : Observable.of<IAppuntamento[]>(null)),
			map(events => events ?
				events.filter(e =>
					e.title.toUpperCase().startsWith(this.paziente)
				)
					.map(e => {
						const begin = moment.utc(e.start);
						return {
							date: begin.format("DD/MM/YYYY"),
							all_day: !e.end,
							begin: begin.format('HH:mm'),
							end: e.end ? moment.utc(e.end).format('HH:mm') : null,
							evento: e.evento
						};
					})
				: null
			),
		);

		this.nextPeriod = (period: IPeriod) => periodRequest.next(period);
	}

	nextPeriod: (period: IPeriod) => void;

	Date = toNgbDateStruct;

	appuntamenti$: Observable<IReminder[]>;

	constructor(public activeModal: NgbActiveModal) {
		// FIXME: Questo sarebbe da mettere in configurazione statica...
		moment.locale(Config.language);
	}

	print() {
		window.print();
	}

	isHovered = date => this.fromDate && !this.toDate && this.hoveredDate && after(date, this.fromDate) && before(date, this.hoveredDate);
	isInside = date => after(date, this.fromDate) && before(date, this.toDate);
	isFrom = date => equals(date, this.fromDate);
	isTo = date => equals(date, this.toDate);
}



// WEBPACK FOOTER //
// ./src/app/anagrafica/selezione-periodo/periodo.ts